module.exports = __webpack_public_path__ + "5823c2656c73d28c8fcf9b0d819dae6c.pdf";